'use client';

import cn from 'classnames';
import type { PropsWithChildren } from 'react';

import { useCacheKey, useDecisions } from '../../hooks';
import type { LayoutContentProps } from './types';
import './LayoutContent.scss';

export function LayoutContent({ layout = 'default', children }: PropsWithChildren<LayoutContentProps>) {
    const { cookies } = useCacheKey();
    const { chat_poc } = useDecisions();
    const open = chat_poc && cookies.get('x-petm-chat') === 'true';

    return (
        <div
            data-testid="layout-content"
            className={cn('layout-content', `layout-content--${layout}`, {
                'layout-content--persistent-drawer-open': open,
                'layout-content--persistent-drawer-closed': !open,
            })}
        >
            {children}
        </div>
    );
}
